import { QueryClient } from "@tanstack/vue-query";

export const DEFAULT_QUERY_CLIENT_OPTIONS = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: __DEV__ ? false : false,
      refetchIntervalInBackground: false,
      retry: false,
      staleTime: 3000,
    },
  },
};

export const queryClient = new QueryClient(DEFAULT_QUERY_CLIENT_OPTIONS);
